import { render } from "./BaseLinkV2.vue?vue&type=template&id=2d572402&scoped=true"
import script from "./BaseLinkV2.vue?vue&type=script&lang=js"
export * from "./BaseLinkV2.vue?vue&type=script&lang=js"

import "./BaseLinkV2.vue?vue&type=style&index=0&id=2d572402&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d572402"]])

export default __exports__